import { observer } from 'mobx-react-lite';
import React from 'react';

import { company } from '~/company/Company';
import { CompanyName } from '~/company/interface';

import { FooterCD } from './FooterCD';
import { FooterCerise } from './FooterCerise';
import { FooterDE } from './FooterDE';
import { FooterElectronium } from './FooterElectronium';
import { LayoutLocaleeV2 } from './LayoutLocaleeV2';

const getFooter = (companyName: CompanyName) => {
  switch (companyName) {
    case CompanyName.CityDrinks:
      return FooterCD;
    case CompanyName.DubaiExpress:
    case CompanyName.DubaiExpressCom:
      return FooterDE;
    case CompanyName.Electronium:
      return FooterElectronium;
    case CompanyName.Cerise:
      return FooterCerise;
    default:
      return LayoutLocaleeV2;
  }
};

export default observer(
  React.forwardRef<
    HTMLDivElement,
    Omit<React.ComponentPropsWithRef<'footer'>, 'children'>
  >((props, ref) => {
    const Content = getFooter(company.name);

    return <Content {...props} ref={ref} />;
  }),
);
